import api from '../../lib/api';

export interface UserGroupFlat {
  id: string;
  name: string;
  parentId: string | null;
}

export interface TreeNode {
  id: string;
  name: string;
  ownerUserId: number;
  parentId: string | null;
  memberCount: number;
  children: TreeNode[];
}

export interface AdminGroupRow {
  id: string;
  name: string;
  ownerUserId: number;
  parentId: string | null;
  owner: { id: number; email: string };
  _count: { members: number };
}

export interface MemberPickerUser {
  id: number;
  email: string;
}

export async function fetchMemberPickerUsers(search?: string): Promise<MemberPickerUser[]> {
  const { data } = await api.get<{ success: boolean; data: { users: MemberPickerUser[] } }>(
    'user-groups/member-picker-users',
    { params: search?.trim() ? { search: search.trim() } : {} }
  );
  return data.data.users;
}

export interface GroupMembershipSummary {
  groupId: string;
  name: string;
  owner: { id: number; email: string };
}

export async function fetchMyGroupMemberships(): Promise<GroupMembershipSummary[]> {
  const { data } = await api.get<{ success: boolean; data: { memberships: GroupMembershipSummary[] } }>(
    'user-groups/me/memberships'
  );
  return data.data.memberships;
}

export async function fetchGroupsFlat(ownerUserId?: number): Promise<UserGroupFlat[]> {
  const { data } = await api.get<{ success: boolean; data: UserGroupFlat[] }>('user-groups/flat', {
    params: ownerUserId ? { ownerUserId } : {},
  });
  return data.data;
}

export type ListGroupsResponse =
  | { view: 'tree'; tree: TreeNode[] }
  | { view: 'all'; items: AdminGroupRow[] };

export async function fetchUserGroupsList(): Promise<ListGroupsResponse> {
  const { data } = await api.get<{ success: boolean; data: ListGroupsResponse }>('user-groups');
  return data.data;
}

export async function createUserGroup(body: {
  name: string;
  parentId?: string | null;
  ownerUserId?: number;
}): Promise<{ id: string; name: string }> {
  const { data } = await api.post<{ success: boolean; data: { id: string; name: string } }>(
    'user-groups',
    body
  );
  return data.data;
}

export async function renameUserGroup(id: string, name: string): Promise<void> {
  await api.patch(`user-groups/${id}`, { name });
}

export async function deleteUserGroup(id: string): Promise<void> {
  await api.delete(`user-groups/${id}`);
}

export interface GroupMemberRow {
  id: string;
  groupId: string;
  userId: number;
  user: { id: number; email: string; role: string };
}

export async function fetchGroupMembers(groupId: string): Promise<GroupMemberRow[]> {
  const { data } = await api.get<{ success: boolean; data: GroupMemberRow[] }>(
    `user-groups/${groupId}/members`
  );
  return data.data;
}

export async function addGroupMember(groupId: string, userId: number): Promise<void> {
  await api.post(`user-groups/${groupId}/members`, { userId });
}

export async function removeGroupMember(groupId: string, userId: number): Promise<void> {
  await api.delete(`user-groups/${groupId}/members/${userId}`);
}
